import { CustomSelectFieldProps, SelectField } from 'components/form'
import { DEFAULT_SELECT_SIZE } from 'components/form/field/select/useAsyncQuerySelect'
import { usePartesBucaisQuery } from 'graphql/hooks.generated'
import { ParteBucalEnum, TipoParteBucalEnum } from 'graphql/types.generated'

export interface LocalTecidosMolesSelectFieldModel {
  value: ParteBucalEnum
  label: string
}

type LocalTecidosMolesSelectFieldProps = DistributiveOmit<
  CustomSelectFieldProps<LocalTecidosMolesSelectFieldModel>,
  'label'
>

export default function LocalTecidosMolesSelectField(props: LocalTecidosMolesSelectFieldProps) {
  const {
    data: { partesBucais },
  } = usePartesBucaisQuery({
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        tiposPartesBucais: [TipoParteBucalEnum.TECIDO_MOLE],
        pageParams: {
          page: { size: DEFAULT_SELECT_SIZE },
        },
      },
    },
  })

  return (
    <SelectField<LocalTecidosMolesSelectFieldModel>
      label='Local'
      items={convertTecidoMoleQueryToModel(partesBucais?.content)}
      itemToString={(i) => i?.label}
      {...props}
    />
  )
}

const convertTecidoMoleQueryToModel = (items) =>
  items?.map((item) => ({ value: item.parteBucalEnum, label: item.descricao } as LocalTecidosMolesSelectFieldModel))
